import { all, takeLatest, put, call } from 'redux-saga/effects';

import { apiRedeemReferralToken } from '../services/apis';
import { updateUserQuota } from '../redux/profile';
import { showAlertBanner } from '../redux/alertBanner';
import * as actions from '../redux/redeemReferralCode';
import {
  ALERT_ERROR_THEME,
  ALERT_SUCCESS_THEME,
} from '../constants/alertBannerThemes';

export function* redeemReferralCode(action) {
  const { userId, code } = action.payload;
  try {
    const response = yield call(apiRedeemReferralToken, {
      userId,
      code,
    });

    const {
      data: { subscriptionQuota, withoutSubscriptionQuota: tokenQuota } = {},
    } = response;

    yield put(
      updateUserQuota({
        subscriptionQuota,
        tokenQuota,
      })
    );
    yield put(actions.redeemReferralCodeSuccess());

    yield put(
      showAlertBanner({
        message: 'account.redeemReferralSuccess',
        theme: ALERT_SUCCESS_THEME,
      })
    );
  } catch (err) {
    yield put(actions.redeemReferralCodeError(err.message));
    yield put(
      showAlertBanner({
        message: err.message,
        theme: ALERT_ERROR_THEME,
      })
    );
  }
}

export default function*() {
  yield all([takeLatest(actions.REDEEM_REFERRAL_CODE, redeemReferralCode)]);
}



// WEBPACK FOOTER //
// ./app/sagas/redeemReferralCode.js